export const comments_5618662 = {"data":{"data":[],"links":{}}}